export default __webpack_public_path__ + "static/magma-bc65cf9d3016d4ecd82e8580cbce2120.png";